import { css } from '@linaria/core';
import theme from '../../../theme';

export const card = css`
  border-radius: 0.75rem;
  background: #ffffff;
  box-shadow: ${theme.elevation.base};
  padding: 1rem;
`;
